import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { makeEventListener } from '../hooks/eventListener';
export const withFirstInteractionHook = WixProGallery => props => {
  const [firstInteractionRecorded, setFirstInteraction] = useState(Boolean(props == null ? void 0 : props.firstInteractionRecorded));
  const trigger = () => {
    !firstInteractionRecorded && setFirstInteraction(true);
  };
  const eventsListener = makeEventListener().HOVER_SET(trigger).GALLERY_SCROLLED(trigger).LOAD_MORE_CLICKED(trigger).ITEM_ACTION_TRIGGERED(trigger).ITEM_CLICKED(trigger).done(props.eventsListener);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    firstInteractionRecorded: firstInteractionRecorded,
    eventsListener: eventsListener
  })));
};
//# sourceMappingURL=withFirstInteractionHook.js.map